import React from "react";
import { Portal } from "@swiggy-private/core-ui";
import { Container } from "./CrossSellM2ItemDetailsBSContainer.style";
import { containerIdForCrossSellM2ItemDetailsBS } from "@cart-ui/constants";

interface IProps {
    index: number;
}

/* 
    The DLS bottomsheet expects to be mounted at the topmost zindex layer in the DOM without clashes with other elements.
    this container will allow us to mount an empty div in root of the DOM before DLS bottomsheet is mounted
    we will give this container some high zindex value so that the DLS bottomsheet can be mounted inside it 
    and indirectly handle low zindex coming from DLS
    root mounts -> container-for-plan-removal-bs with high zindex (this-component) mounts -> DLS bottomsheet with lower zindex
    2 Portals - One for this container to be mounted in root, second for DLS bottomsheet to be mounted in this container
*/
const CrossSellM2ItemDetailsBSContainer = ({ index }: IProps) => {
    return (
        <Portal>
            <Container id={`${containerIdForCrossSellM2ItemDetailsBS}_${index}`} />
        </Portal>
    );
};

export default CrossSellM2ItemDetailsBSContainer;
